// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import bootstrap from "../../node_modules/bootstrap/dist/js/bootstrap";
import owl from "../../node_modules/owl.carousel/dist/owl.carousel";
import AOS from "../../node_modules/aos/dist/aos";

import owlCarousel from "./components/owl-carousel";
const Header = require('./partials/_header.js');
const Animations = require('./partials/_animations.js');
const Home = require('./templates/home.js');

// Initialise our components on jQuery.ready…
jQuery(function ($) {
    AOS.init({
        duration: 1400
    });
});